import React from "react";
import { DndProvider } from "react-dnd";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import Authenticated from "./Authenticated";
import "./App.css";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { TruckDetailProvider } from "./context/TruckDetailsContext";
import { MaterialsProvider } from "./context/materialListingContext";
import { TruckMaterialFormFlowProvider } from "./context/TruckMaterialFormFlowContext";
import { WrapperProvider } from "./context/WrapperContext";
import { TicketProcessingFiltersProvider } from "./context/TicketProcessingFilterContext";
import { CustomerDatabaseFilterContextProvider } from "./context/CustomerDatabaseFilterContext";
import { JobDatabaseFilterContextProvider } from "./context/JobDatabaseFilterContext";
import { QuarryDatabaseFilterContextProvider } from "./context/QuarryDatabaseFilterContext";
import { LienProcessFilterContextProvider } from "./context/LienProcessFilterContext";
import { HTML5Backend } from "react-dnd-html5-backend";

function App(props) {
  const queryClient = new QueryClient();
  return (
    <div className="App">
      <WrapperProvider>
        <TruckMaterialFormFlowProvider>
          <QueryClientProvider client={queryClient}>
            <Router>
              <MaterialsProvider>
                <TruckDetailProvider>
                  <QuarryDatabaseFilterContextProvider>
                    <JobDatabaseFilterContextProvider>
                      <LienProcessFilterContextProvider>
                        <CustomerDatabaseFilterContextProvider>
                          <TicketProcessingFiltersProvider>
                            <DndProvider backend={HTML5Backend}>
                              <Switch>
                                <Route path="/" component={Authenticated} />
                              </Switch>
                            </DndProvider>
                          </TicketProcessingFiltersProvider>
                        </CustomerDatabaseFilterContextProvider>
                      </LienProcessFilterContextProvider>
                    </JobDatabaseFilterContextProvider>
                  </QuarryDatabaseFilterContextProvider>
                </TruckDetailProvider>
              </MaterialsProvider>
            </Router>
          </QueryClientProvider>
        </TruckMaterialFormFlowProvider>
      </WrapperProvider>
    </div>
  );
}
export default App;
